import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToastService } from '@irembo-andela/irembogov3-common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs';
import { NotificationTemplate } from '../../../../../../core/models/notification.model';
import { ServiceChangeRequestService } from '../../../../../../core/services/service-change-request.service';

interface TemplateParams {
  page: number;
  pageSize: number;
  type: 'EMAIL' | 'SMS';
  name?: string;
}
@Component({
  selector: 'irembogov-choose-notifification-template',
  templateUrl: './choose-notifification-template.component.html',
  styleUrls: ['./choose-notifification-template.component.scss'],
})
export class ChooseNotifificationTemplateComponent implements OnInit {
  loadingTemplates = false;
  templates: NotificationTemplate[] = [];
  uniqueTemplateNames: NotificationTemplate[] = [];
  domParser = new DOMParser();
  searchFormControl = new FormControl('');
  params: TemplateParams = {
    page: 0,
    pageSize: 30,
    type: 'EMAIL',
  };
  pagination = {
    totalItems: 0,
  };

  @Input() isEmail = false;

  constructor(
    public activeModal: NgbActiveModal,
    private serviceChangeRequestService: ServiceChangeRequestService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.params.type = this.isEmail ? 'EMAIL' : 'SMS';

    this.getTemplates(this.params);

    this.searchFormControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(value => {
        this.params.name = value ? value.trim() : '';
        this.params.page = 0;
        this.getTemplates(this.params);
      });
  }

  getTemplates(params: TemplateParams) {
    this.loadingTemplates = true;

    let stringifiedParams = `page=${params.page}&pageSize=${params.pageSize}&type=${params.type}`;

    if (params.name) {
      stringifiedParams += `&name=${params.name}`;
    }

    this.serviceChangeRequestService
      .getServiceNotificationTemplates(stringifiedParams)
      .pipe(finalize(() => (this.loadingTemplates = false)))
      .subscribe({
        next: response => {
          this.templates = this.getStringifiedTemplates(
            response.data.templates
          );
          this.uniqueTemplateNames = this.templates.filter(
            (template, index, self) =>
              index ===
              self.findIndex(t => t.templateName === template.templateName)
          );
          this.pagination.totalItems = response.data.totalTemplates;
        },
        error: error => {
          this.toastService.show({
            type: 'error',
            body: error.error.message,
          });
        },
      });
  }

  getStringifiedTemplates(
    templates: NotificationTemplate[]
  ): NotificationTemplate[] {
    return templates.map(template => {
      const doc = this.domParser.parseFromString(
        template.template,
        'text/html'
      );

      if (doc.body) {
        let stringifiedTemplate = doc.body.innerHTML;
        stringifiedTemplate = stringifiedTemplate.replace(
          '${year}',
          new Date().getFullYear().toString()
        );
        template.stringifiedTemplate = stringifiedTemplate;
      }

      return template;
    });
  }

  getResponsiveColumnClass(): string {
    const count = this.uniqueTemplateNames.length;

    if (count === 1) return 'col-12';
    if (count === 2) return 'col-12 col-md-6';
    if (count >= 3) return 'col-12 col-md-6 col-lg-4';

    return 'col-4';
  }

  selectTemplate(template: NotificationTemplate) {
    this.activeModal.close(
      this.templates.filter(t => t.templateName === template.templateName)
    );
  }

  onPaginationChange(event: { pageNumber: number; pageSize: number }) {
    this.params.page = event.pageNumber - 1;
    this.params.pageSize = event.pageSize;

    this.getTemplates(this.params);
  }
}
